import React, {
  ReactElement,
  useMemo,
  useState,
  useCallback,
  useEffect
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import style from './app.module.css';
import ImproveContent from '../../components/improve-content/improve-content';
import Rate from '../../../../components/rate/rate';
import Toast from '../../../../components/toast';
import { submitQuestionnaire } from '../../../../api/pile-apply';
import {
  closeWindow,
  getPlatform,
  go2LoginIfNot,
  webviewOpen
} from '../../../../utils/common';
import OrdinaryModel from '../../../../components/ordinary-model';
import Confirm from '../../../../components/confirm';
import FullLoading from '../../../../components/full-loading';

enum ServiceWeakness {
  negotiationTrouble,
  considerOtherBrands,
  functionalImperfection,
  noFixedParkingSpace,
  theCostOfAdditionalItemsIsHigh,
  customerServiceReplyIsNotTimely,
  poorCustomerServiceAttitude,
  refundReshoot,
  other
}

const App = (): ReactElement => {
  const router = useHistory();
  const loc = useLocation();
  const orderNo: any = new URLSearchParams(loc.search).get('orderNo');
  // 留言
  const [comment, setComment] = useState('');
  // 改进选项
  var improveArray = [
    { name: '电力报装/物业协商', value: ServiceWeakness.negotiationTrouble },
    { name: '考虑其他品牌', value: ServiceWeakness.considerOtherBrands },
    { name: '功能不完善', value: ServiceWeakness.functionalImperfection },
    { name: '无固定车位', value: ServiceWeakness.noFixedParkingSpace },
    { name: '增项费用高', value: ServiceWeakness.theCostOfAdditionalItemsIsHigh },
    { name: '服务不及时', value: ServiceWeakness.customerServiceReplyIsNotTimely },
    { name: '服务人员态度差', value: ServiceWeakness.poorCustomerServiceAttitude },
    { name: '退款重拍', value: ServiceWeakness.refundReshoot },
    { name: '其他', value: ServiceWeakness.other }
  ];
  // 选中项
  const [selected, setSelected] = useState<number[]>([]);

  const [userInfo, setUserInfo] = useState({ uid: '', name: '' });

  const [rateVal, setRateVal] = useState(0);

  const [isSubmiting, setIsSubmiting] = useState(false);

  const [showPopup, setShowPopup] = useState<boolean>(false);

  useEffect(() => {
    document.title = '评价服务';
  }, []);

  const handleSelect = useCallback(
    (val: number[]) => {
      setSelected(val);
    },
    [selected]
  );

  const btnCanSubmit = useMemo(() => {
    if (!rateVal) return false;
    if (rateVal <= 4 && selected.length === 0) return false;
    if (selected && selected.includes(ServiceWeakness.other) && !comment) return false;
    return true;
  }, [rateVal, selected, comment]);

  const improveVisible = useMemo(() => {
    if (rateVal <= 4 && rateVal !== 0) return true;
    return false;
  }, [rateVal]);

  const handleChange = e => {
    const val = e.target.value;
    setComment(val);
  };

  const handleRate = val => {
    if (val > 3) {
      setSelected([]);
    }
    setRateVal(val);
  };

  const cancelFn = () => {
    setShowPopup(false);
    router.goBack();
  };
  const confirmFn = () => {
    setShowPopup(false);
    webviewOpen('xiaopeng://account/charging/my?goBLE=1');
    closeWindow();
  };
  const submit = () => {
    if (!btnCanSubmit) {
      Toast.show({
        text: '请完成表单',
        duration:2000
      });
      return;
    }
    setIsSubmiting(true);
    if (isSubmiting) {
      // Toast.show({
      //   text: '提交中'
      // });
      FullLoading.show({
        text:"提交中"
      })
      return;
    }
    submitQuestionnaire({
      orderNo: orderNo,
      mark: rateVal,
      negotiationTrouble: selected.indexOf(ServiceWeakness.negotiationTrouble) !== -1 ? 1 : 0,
      considerOtherBrands: selected.indexOf(ServiceWeakness.considerOtherBrands) !== -1 ? 1 : 0,
      functionalImperfection: selected.indexOf(ServiceWeakness.functionalImperfection) !== -1 ? 1 : 0,
      noFixedParkingSpace: selected.indexOf(ServiceWeakness.noFixedParkingSpace) !== -1 ? 1 : 0,
      theCostOfAdditionalItemsIsHigh: selected.indexOf(ServiceWeakness.theCostOfAdditionalItemsIsHigh) !== -1 ? 1 : 0,
      customerServiceReplyIsNotTimely: selected.indexOf(ServiceWeakness.customerServiceReplyIsNotTimely) !== -1 ? 1 : 0,
      poorCustomerServiceAttitude: selected.indexOf(ServiceWeakness.poorCustomerServiceAttitude) !== -1 ? 1 : 0,
      refundReshoot: selected.indexOf(ServiceWeakness.refundReshoot) !== -1 ? 1 : 0,
      other: selected.indexOf(ServiceWeakness.other) !== -1 ? 1 : 0,
      info: comment,
      uid: userInfo.uid ? userInfo.uid : '',
      name: userInfo.name ? userInfo.name : ''
    })
      .then(() => {
        setIsSubmiting(false);
        console.log('提交成功');
        setShowPopup(true);
        Toast.show({
          text: '提交成功',
          duration: 2000
        });
        FullLoading.hide()
      })
      .catch(e => {
        console.log('提交表单失败', e);
        Toast.show({
          text: e.message || '提交失败',
          duration: 2000
        });
        setIsSubmiting(false);
        FullLoading.hide()
      });
  };

  useEffect(() => {
    go2LoginIfNot()
      .then(loginData => {
        if (!loginData) {
          Confirm.open('请先登录', {
            type: 2,
            confirmText: '确定',
            header: '',
            confirmCbk: (destroy): void => {
              destroy();
              // 关闭h5
              closeWindow();
            }
          });
        } else {
          // 已登录
          const phoneModel = getPlatform();
          let name: string = loginData.username;
          if (phoneModel === 'android') {
            name = loginData.nickname;
          }
          setUserInfo({ uid: loginData.uid, name: name });
        }
      })
      .catch(e => {
        console.log('页面出错', e.message);
        closeWindow();
      });
  }, []);

  return (
    <div className={style.wrap}>
      <div className={style.content}>
        <p className={style.title}>你对本次安装服务的满意度</p>
        <Rate value={rateVal} onChange={handleRate}></Rate>
        {improveVisible && (
          <>
            <ImproveContent
              content={improveArray}
              selected={selected}
              handleSelect={handleSelect}
            ></ImproveContent>
          </>
        )}
        <p className={`${style.commentTitle} ${selected && selected.includes(ServiceWeakness.other) && style.required}`}>
          请问你在安装家充时遇到了什么问题？
        </p>
        <div className={style.inputWrap}>
          <textarea
            className={style.input}
            placeholder="请输入"
            onChange={handleChange}
            value={comment}
          ></textarea>
        </div>
      </div>

      <div className={style.bottom}>
        <button
          className={`${!btnCanSubmit ? '' : style.btn} ${style.disabledBtn}`}
          onClick={submit}
        >
          提交评价
        </button>
      </div>
      {showPopup && (
        <OrdinaryModel
          type={2}
          content={'评价成功，是否开始使用充电桩'}
          cancelCbk={cancelFn}
          cancelText={'暂不使用'}
          confirmText={'前往使用'}
          confirmCbk={confirmFn}
        />
      )}
    </div>
  );
};

export default App;
